'use client';

import { HighlightBannerPip } from '@wwe-portal/ui/features/dashboard-revamp/highlight';
import {
  useIsAuthenticated,
  useIsAuthenticating,
} from '@wwe-portal/web/providers/stores/auth-store';
import { getDashboardPipStore } from '@wwe-portal/web/providers/stores/dashboard-pip-store';
import { Item } from '@wwe-portal/entities/dashboard.type';
import { FC, useEffect, useState } from 'react';

export const UserBannerPip: FC<{ item: Item }> = ({ item }) => {
  const isAuthenticated = useIsAuthenticated();
  const isAuthenticating = useIsAuthenticating();
  const [hasPip, setHasPip] = useState<boolean>(false);
  useEffect(() => {
    let isUnmounted = false;
    getDashboardPipStore()
      .getState()
      .hasPip(item)
      .then((value) => {
        if (isUnmounted) return;
        setHasPip(value);
      });
    return () => {
      isUnmounted = true;
    };
  }, [item]);

  return hasPip || (!isAuthenticating && !isAuthenticated) ? (
    <HighlightBannerPip />
  ) : null;
};
